var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIMyPositionLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9973 22.3132C18.1411 22.3132 22.311 18.1432 22.311 12.9992C22.311 7.85521 18.1411 3.68518 12.9973 3.68518C7.85348 3.68518 3.68359 7.85521 3.68359 12.9992C3.68359 18.1432 7.85348 22.3132 12.9973 22.3132Z",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0027 16.061C14.6935 16.061 16.0641 14.6903 16.0641 12.9995C16.0641 11.3088 14.6935 9.93811 13.0027 9.93811C11.312 9.93811 9.94141 11.3088 9.94141 12.9995C9.94141 14.6903 11.312 16.061 13.0027 16.061Z",
    fill: "#10141A",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.68524V1",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.9988V22.3136",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3164 12.9994H25.0016",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.9994H3.68515",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMyPositionLg);
export default __webpack_public_path__ + "static/media/i_my_position_lg.8c1a4af61d894562be58191dcd57c759.svg";
export { ForwardRef as ReactComponent };